// extracted by mini-css-extract-plugin
export default {"container":"container__ljm74II","icon":"icon__YmCY7+r","text":"text__E3uakxw"};